export default {
  sm: `
  DATA CENTER GAK Brand Mark
  `,
  lg: `
  DATA CENTER GAK
  Brand Mark
  `,
};
